<template>
  <div id="app">

    <div class="inner-app">
      <layoutDefault />
    </div>

    <div id="landscape-message">
      Please rotate your device to portrait mode for the best experience.
    </div>

  </div>
</template>

<script>
import layoutDefault from './layouts/Default'

export default {
  name: 'App',
  components: {
    layoutDefault
  },
  mounted() {
    this.lockScreenOrientation();
  },
  methods: {
    lockScreenOrientation() {
      // Check if the screen orientation API is available
      if (window.screen && window.screen.orientation && typeof window.screen.orientation.lock === 'function') {
        // Attempt to lock the screen orientation to portrait
        window.screen.orientation.lock('portrait')
          .catch(err => {
            // Handle the error - orientation lock may not be supported or allowed
            console.warn('Screen orientation lock not supported or not allowed:', err);
          });
      } else {
        console.warn('Screen orientation API not available');
      }
    }
  }
}
</script>

<style>
/* Default styles for the message; hide it */
#landscape-message {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  font-size: 1.5rem;
  text-align: center;
  padding: 20%;
  z-index: 9999;
}

/* Apply only for devices with max-width 767px and in landscape mode */
@media only screen 
  and (max-device-width: 767px) 
  and (orientation: landscape) {
    #landscape-message {
        display: block;
    }
}
</style>
